"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoratedWorkspaceAttributesService = void 0;
/**
 * @alpha
 */
var DecoratedWorkspaceAttributesService = /** @class */ (function () {
    function DecoratedWorkspaceAttributesService(decorated) {
        this.decorated = decorated;
    }
    DecoratedWorkspaceAttributesService.prototype.elements = function () {
        return this.decorated.elements();
    };
    DecoratedWorkspaceAttributesService.prototype.getAttributeDisplayForm = function (ref) {
        return this.decorated.getAttributeDisplayForm(ref);
    };
    DecoratedWorkspaceAttributesService.prototype.getAttributeDisplayForms = function (refs) {
        return this.decorated.getAttributeDisplayForms(refs);
    };
    DecoratedWorkspaceAttributesService.prototype.getAttribute = function (ref) {
        return this.decorated.getAttribute(ref);
    };
    DecoratedWorkspaceAttributesService.prototype.getAttributeByDisplayForm = function (ref) {
        return this.decorated.getAttributeByDisplayForm(ref);
    };
    DecoratedWorkspaceAttributesService.prototype.getAttributes = function (refs) {
        return this.decorated.getAttributes(refs);
    };
    DecoratedWorkspaceAttributesService.prototype.getCommonAttributes = function (attributeRefs) {
        return this.decorated.getCommonAttributes(attributeRefs);
    };
    DecoratedWorkspaceAttributesService.prototype.getCommonAttributesBatch = function (attributesRefsBatch) {
        return this.decorated.getCommonAttributesBatch(attributesRefsBatch);
    };
    DecoratedWorkspaceAttributesService.prototype.getAttributeDatasetMeta = function (ref) {
        return this.decorated.getAttributeDatasetMeta(ref);
    };
    return DecoratedWorkspaceAttributesService;
}());
exports.DecoratedWorkspaceAttributesService = DecoratedWorkspaceAttributesService;
//# sourceMappingURL=attributes.js.map